import { render, staticRenderFns } from "./home-about.vue?vue&type=template&id=664d7f77"
import script from "./home-about.vue?vue&type=script&lang=js"
export * from "./home-about.vue?vue&type=script&lang=js"
import style0 from "./home-about.vue?vue&type=style&index=0&id=664d7f77&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports